import * as Types from '../../tenants/kwg/generated';


export const RoleAssignmentFragmentDoc = `
    fragment RoleAssignment on RoleAssignment {
  id
  userId
  groupId
  objectType
  roleType
  dossierId
}
    `;
export const RoleAssignmentWithDetailsFragmentDoc = `
    fragment RoleAssignmentWithDetails on RoleAssignment {
  id
  userId
  groupId
  objectType
  roleType
  dossierId
  user {
    id
    name
    email
  }
  group {
    id
    name
  }
}
    `;
// @ts-ignore
// auto-added to satisfy TS unused import
void 0 && Types;
